import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Location, PopStateEvent } from "@angular/common";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];
  fullscreen: string[] = [];

  constructor(private router: Router, private location: Location) { }

  ngOnInit() {
    this.location.subscribe((ev: PopStateEvent) => {
      this.lastPoppedUrl = ev.url;
    });
    this.router.events.subscribe((ev: any) => {
      if (ev instanceof NavigationStart) {
        if (ev.url != this.lastPoppedUrl)
          this.yScrollStack.push(window.scrollY);
      } else if (ev instanceof NavigationEnd) {
        if (this.fullscreen.includes(ev.url)) {
          sessionStorage.setItem('sidebarstate', 'closed');

          sessionStorage.setItem('toolbar', 'false');
        } else {
          if (!this.isMobile()) {
            sessionStorage.setItem('sidebarstate', 'open');
          }
          sessionStorage.removeItem('toolbar');
        }
        if (ev.url == this.lastPoppedUrl) {
          this.lastPoppedUrl = undefined;
          window.scrollTo(0, this.yScrollStack.pop());
        } else
          window.scrollTo(0, 0);
      }
    });
  }

  isMobile() {
    if (window.outerWidth <= 1025) {
      return true;
    } else {
      return false;
    }
  }
}
